import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import Toast6 from './toast6'
import './footer4.css'

const Footer4 = (props) => {
  return (
    <footer className="footer4-footer7 thq-section-padding">
      <Link to="/" className="footer4-navlink1">
        <img
          alt={props.imageAlt}
          src={props.imageSrc}
          className="footer4-image"
        />
      </Link>
      <Toast6></Toast6>
      <div className="footer4-max-width thq-section-max-width">
        <div className="footer4-content">
          <div className="footer4-links">
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              className="thq-body-small"
            >
              {props.link1 ?? (
                <Fragment>
                  <span className="footer4-text18">About Us</span>
                </Fragment>
              )}
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              className="thq-body-small"
            >
              {props.link2 ?? (
                <Fragment>
                  <span className="footer4-text17">Services</span>
                </Fragment>
              )}
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              className="thq-body-small"
            >
              {props.link3 ?? (
                <Fragment>
                  <span className="footer4-text14">Contact US</span>
                </Fragment>
              )}
            </a>
            <Link to="/dei-policy" className="footer4-navlink2 thq-body-small">
              {props.link4 ?? (
                <Fragment>
                  <span className="footer4-text19">DEI Policy</span>
                </Fragment>
              )}
            </Link>
          </div>
        </div>
        <div className="footer4-credits">
          <div className="thq-divider-horizontal"></div>
          <div className="footer4-row">
            <div className="footer4-container">
              <span className="thq-body-small">© 2025 Allstream Global</span>
            </div>
            <div className="footer4-footer-links">
              <span className="footer4-text11 thq-body-small">
                {props.privacyLink ?? (
                  <Fragment>
                    <span className="footer4-text16">Privacy Policy</span>
                  </Fragment>
                )}
              </span>
              <span className="thq-body-small">
                {props.termsLink ?? (
                  <Fragment>
                    <span className="footer4-text20">Terms of Service</span>
                  </Fragment>
                )}
              </span>
              <span className="thq-body-small">
                {props.cookiesLink ?? (
                  <Fragment>
                    <span className="footer4-text15">Cookies Settings</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer4.defaultProps = {
  imageAlt: 'image',
  link3: undefined,
  cookiesLink: undefined,
  privacyLink: undefined,
  link2: undefined,
  link1: undefined,
  link4: undefined,
  termsLink: undefined,
  imageSrc: '/logo-200h.png',
}

Footer4.propTypes = {
  imageAlt: PropTypes.string,
  link3: PropTypes.element,
  cookiesLink: PropTypes.element,
  privacyLink: PropTypes.element,
  link2: PropTypes.element,
  link1: PropTypes.element,
  link4: PropTypes.element,
  termsLink: PropTypes.element,
  imageSrc: PropTypes.string,
}

export default Footer4
